import { z } from 'zod'

export const validateCountry = () =>
  z
    .object({
      code: z.string(),
    })
    .transform((arg, ctx) => {
      if (!arg) {
        ctx.addIssue({
          code: 'custom',
          message: 'Country is required',
        })
        return z.NEVER
      }

      return arg.code
    })
